export const CHANNEL_GROUP_LABEL: Record<string, string> = {
  ad: "Paid Social",
  organic: "Organic Social",
  mentions: "Earned Media",
  subscription: "Subscription",
  search: "Search",
  unattributed: "Unattributed",
}

export const CHANNEL_GROUP_COLOR: Record<string, string> = {
  ad: "bg-charts-orange",
  organic: "bg-charts-cyan",
  mentions: "bg-yellow-info",
  search: "bg-sky-blue",
  subscription: "bg-green",
  unattributed: "bg-blue-ultra",
}
